import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxPermissionsModule } from "ngx-permissions";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { PipesModule } from "../../pipes/pipes.module";
import { MaterialModule } from "../../components/material/material.module";
import { TelefonoModule } from "../../components/telefono/telefono.module";
import { AutorizadorModule } from "../../components/autorizador/autorizador.module";
import { ContactoService } from "../../providers/contacto.service";
import { VerClasificacionClientesComponent } from "./ver-clasificacion-clientes/ver-clasificacion-clientes.component";
import { CrearClasificacionClientesComponent } from "./crear-clasificacion-clientes/crear-clasificacion-clientes.component";
import { ClasificacionClientesComponent } from "./clasificacion-clientes/clasificacion-clientes.component";
import { EditarClasificacionClientesDialogComponent } from "./editar-clasificacion-clientes/editar-clasificacion-clientes-dialog/editar-clasificacion-clientes-dialog.component";
import { CrearClasificacionClientesDialogComponent } from "./crear-clasificacion-clientes/crear-clasificacion-clientes-dialog/crear-clasificacion-datos-dialog.component";
import { ClasificacionClientesService } from "../../providers/clasificacion-clientes.service";
import { EditarClasificacionClientesComponent} from "./editar-clasificacion-clientes/editar-clasificacion-clientes.component";

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        ReactiveFormsModule,
        FormsModule,
        PipesModule,
        MaterialModule,
        TelefonoModule,
        AutorizadorModule,
    ],
    declarations: [
        CrearClasificacionClientesComponent,
        CrearClasificacionClientesDialogComponent,
        EditarClasificacionClientesComponent,
        EditarClasificacionClientesDialogComponent,
        ClasificacionClientesComponent,
        VerClasificacionClientesComponent
    ],
    providers: [
        ClasificacionClientesService
    ],
    entryComponents: [
        CrearClasificacionClientesDialogComponent,
        EditarClasificacionClientesDialogComponent,
    ],
    exports: [
        CrearClasificacionClientesComponent,
        EditarClasificacionClientesComponent,
        ClasificacionClientesComponent,
        VerClasificacionClientesComponent,
    ]
})
export class ClasificacionClientesEModule { }